import React, { useState } from 'react';
import {
  Grid,
  Divider,
  Stack,
  InputAdornment,
  TextField,
  IconButton,
} from '@mui/material';
import { textFieldProps } from '../constants/form';
import { useTranslation } from 'react-i18next';
import { ChangePassword } from './index';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';

export default function Password({
  changePasswordData,
  setChangePasswordData,
}: {
  changePasswordData: ChangePassword;
  setChangePasswordData: React.Dispatch<React.SetStateAction<ChangePassword>>;
}): JSX.Element {
  const { t: tMA } = useTranslation([], { keyPrefix: 'team.Modals.Account' });

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  return (
    <>
      <Divider sx={{ marginBottom: 1 }} />
      <Stack
        gap={2}
        direction={'row'}
        justifyContent={'space-around'}
        width={'100%'}
        sx={{ marginY: 2 }}
      >
        <Stack gap={2} width={'100%'}>
          <Grid>
            <TextField
              variant="filled"
              {...textFieldProps}
              label={tMA('Old Password')}
              name="oldPassword"
              type={showOldPassword ? 'text' : 'password'}
              error={Boolean(changePasswordData.oldPasswordError)}
              helperText={changePasswordData.oldPasswordError}
              value={changePasswordData.oldPassword}
              onChange={(e) =>
                setChangePasswordData({
                  ...changePasswordData,
                  oldPasswordError: '',
                  oldPassword: e.target.value,
                })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() => setShowOldPassword((prev) => !prev)}
                      onMouseDown={(e) => e.preventDefault()} // keeps focus in the input
                    >
                      {showOldPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid>
            <TextField
              variant="filled"
              {...textFieldProps}
              label={tMA('New Password')}
              name="newPassword"
              type={showNewPassword ? 'text' : 'password'}
              error={Boolean(changePasswordData.newPasswordError)}
              helperText={changePasswordData.newPasswordError}
              value={changePasswordData.newPassword}
              onChange={(e) =>
                setChangePasswordData({
                  ...changePasswordData,
                  newPasswordError: '',
                  newPassword: e.target.value,
                })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() => setShowNewPassword((prev) => !prev)}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Stack>
      </Stack>
    </>
  );
}
